// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateColombianExternalPayProvider(externalpayprovidercode: string): ?UserInputValidationError {
  return externalpayprovidercode ? VALID : { id: 'empty' };
}
